var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulseFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM9.647 17.882a.59.59 0 00.588-.588V6.706a.59.59 0 00-.588-.588.59.59 0 00-.588.588v10.588a.59.59 0 00.588.588zm4.706-1.176a.59.59 0 00.588-.588V7.882a.59.59 0 00-.588-.588.59.59 0 00-.588.588v8.236a.59.59 0 00.588.588zm2.941-2.353a.59.59 0 01-.588.588.59.59 0 01-.588-.588V9.647a.59.59 0 01.588-.588.59.59 0 01.588.588v4.706zm1.765-1.176a.59.59 0 01-.588-.589v-1.176a.59.59 0 01.588-.589.59.59 0 01.588.589v1.176a.59.59 0 01-.588.589zm-6.47 1.764a.59.59 0 01-.589.588.59.59 0 01-.588-.588V9.06A.59.59 0 0112 8.47a.59.59 0 01.588.588v5.882zm-4.707-.588a.59.59 0 01-.588.588.59.59 0 01-.588-.588V9.647a.59.59 0 01.588-.588.59.59 0 01.588.588v4.706zm-2.94-1.176a.59.59 0 00.587-.589v-1.176a.59.59 0 00-.588-.589.59.59 0 00-.588.589v1.176a.59.59 0 00.588.589z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseFill);
export default __webpack_public_path__ + "f53d6fd6446f863a55452d5f167c2e5d.svg";
export { ForwardRef as ReactComponent };